import designPortal from "./design-portal.slice";

export * from "./design-portal.saga";
export * from "./design-portal.slice";

export default designPortal.reducer;
